export default "__VITE_ASSET__BbNqCfic__"